// extracted by mini-css-extract-plugin
export var bottomBorder = "styles-module__bottomBorder___k1UKo";
export var rightContainer = "styles-module__rightContainer___RhQ3K";